module.exports = __webpack_public_path__ + "img/23.187e34cc.svg";